<div [ngSwitch]="icon" class="prefix">
  <i class="fa {{iconClasses}}" *ngSwitchCase="true"></i>
</div>
<div [ngSwitch]="isThisRequired">
  <input 
    class="form-control {{additionalClasses}}" 
    id="{{inputName}}" 
    name="{{inputName}}"
    placeholder="no" 
    type="{{inputType}}"
    mdbInput
    *ngSwitchCase="false"
  />
  <input class="form-control {{additionalClasses}}" 
    id="{{inputName}}" 
    name="{{inputName}}"
    placeholder="yes"
    type="{{inputType}}"
    mdbInput
    required
    *ngSwitchCase="true"
  />
</div>
<mapfre-label forInput="{{inputName}}"><ng-content></ng-content></mapfre-label>
